// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import PassiveRow from './PassiveRow'

// tooltipData is the passiveSummary from the parsed row data.

const PassiveTooltip = ({ idRoot, tooltipData }) => (
  <dl>
    <dt>
      <p className={`tooltip-trigger-decoration show-decoration num-repeaters-${tooltipData.length}`}>{'P'}</p>
    </dt>
    {tooltipData.map((d, i) => (
      <PassiveRow
        key={i}
        idRoot={`${idRoot}passive-${i}-`}
        {...d} />
    ))}
  </dl>
)

PassiveTooltip.propTypes = {
  idRoot: string.isRequired,
  tooltipData: array.isRequired,
}

export default PassiveTooltip
